// extracted by mini-css-extract-plugin
export default {"scroll_top_main":"ScrollTopWhite_scroll_top_main__mOlPg","scrollIcon":"ScrollTopWhite_scrollIcon__z6qbM"};